import type { SidePanel } from '../types';

export const Topup: SidePanel.VueComponent = {
  component: defineAsyncComponent(() => import('./TopupCashPanel.vue')),
};
